import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetLearningStatsResponse } from './get-learning-stats-response';
import { getLearningStatsResponseSchema } from './get-learning-stats-response';

export async function getLearningStatsApi(
  days: number = 30,
): Promise<IValidatedResponse<IGetLearningStatsResponse>> {
  return getRequest<IGetLearningStatsResponse>({
    path: '/sys/monitoring/learning',
    schema: getLearningStatsResponseSchema,
    options: { params: { days } },
  });
}
